/*
 * Authentication
 * ---------------
 *
 * Authentication service which checks whether or not the user is authenticated. For the purposes
 * of stateless authentication with JWT, that is simply a matter of whether the token is expired
 *
 */

import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { JwtHelperService } from '@auth0/angular-jwt'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { HttpHeaders } from '@angular/common/http';

const TOKEN_NAME = 'class_hive_auth_token'
const FIRST_NAME = 'firstname'
const CLASSHIVE_CODE = 'user.classhive_code'
const CH_USER_PORIFLE = 'user.profile'

@Injectable()
export class AuthService {

  constructor(public jwtHelper: JwtHelperService, private http:HttpClient) {
  }

  static token() {
    return sessionStorage.getItem(TOKEN_NAME)
  }

  static setToken(token) {
    sessionStorage.setItem(TOKEN_NAME, token)
  }

  public isAuthenticated(): boolean {
    const token = AuthService.token()
    if (token === null || typeof token === 'undefined') {
      return false;
    }
    console.log('Token Expired: ', this.jwtHelper.isTokenExpired(token))
    this.getTokenPayload()
    return !this.jwtHelper.isTokenExpired(token)
  }

  public decode() {
    const token = AuthService.token()
    return this.jwtHelper.decodeToken(token)
  }

  public expires() {
    const token = AuthService.token()
    this.jwtHelper.getTokenExpirationDate()
  }

  public getTokenPayload() {
    const token = AuthService.token()
    if (token) {
      var userPayload = atob(token.split('.')[1])
      console.log("Payload:", JSON.parse(userPayload))
      return JSON.parse(userPayload)
    }
    else {
      console.log("Payload Null")
      return null
    }

  }

  public login(username, password) {
    return this.http
      .post<any>(`/api/v2/login`, {username: username, password: password})
      .pipe(
        map(result => {
          if (result.status === 200) {

            let decodedToken = {};

            try {
              decodedToken = this.jwtHelper.decodeToken(result.token)

            } catch (error) {
              return {status:404, message:'Invalid token. You may try again later or contact us'}
            }

            this.setUserDetails(result.token, decodedToken)
          }

          return result
        })
      )
  }

  public qr_code_login(classhive_code) {
    return this.http
      .post<any>(`/api/v2/login/qr_code`, {classhive_code: classhive_code})
      .pipe(
        map(data => {
          let result: any = data

          if (result.status === 200) {

            let decodedToken: any = {};

            try {
              decodedToken = this.jwtHelper.decodeToken(result.token)

            } catch (error) {
              return {status:404, message:'Invalid token. You may try again later or contact us'}
            }

            if (
              decodedToken
              && Object.keys(decodedToken).length > 0
              && (
                decodedToken.ch_access_pin !== null
                && decodedToken.ch_access_pin !== ''
              )
            ) {

              const { ch_access_pin } = decodedToken

              result = {
                ...result,
                status: 202,
                chAccessPin: ch_access_pin
              }

            } else {
              this.setUserDetails(result.token, decodedToken)
            }

          }

          return result
        })
      )
  }

  public handlePinLogin = async (token) => {
    let decodedToken = null

    try {
      decodedToken = await this.jwtHelper.decodeToken(token)

    } catch (error) {
      return {status:404, message:'Invalid token. You may try again later or contact us'}
    }

    this.setUserDetails(token, decodedToken)
  }

  public setUserDetails(token, decodedToken) {
    AuthService.setToken(token)
    this.updateUserInfo(decodedToken)
  }

  public updateUserInfo(decodedToken) {
    sessionStorage.setItem(FIRST_NAME, decodedToken.firstname)
  }

  public logout() {
    sessionStorage.removeItem(TOKEN_NAME)
    sessionStorage.removeItem(FIRST_NAME)
    sessionStorage.removeItem(CLASSHIVE_CODE)
    sessionStorage.removeItem(CH_USER_PORIFLE)
  }
  
}
